import {
  createDetailReducer,
  createListReducer,
} from '../../common/services/reducerCreator';

export const usersReducer = createListReducer('USERS');
export const userReducer = createDetailReducer({
  modelName: 'USER',
});
